import { Outlet } from 'react-router-dom';

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:ital,wght@0,400;0,600;0,700;0,800;0,900;1,700&display=swap');

  :root {
    --g-black: #0a0a0a;
    --g-orange: #ff4d00;
    --g-white: #f8f6f1;
    --g-gray: #2a2a2a;
    --g-muted: #888;
    --g-radius: 2px;
    --g-max: 480px;
  }

  .g-wrap {
    min-height: 100dvh;
    background: var(--g-black);
    color: var(--g-white);
    font-family: 'Barlow Condensed', sans-serif;
    display: flex;
    flex-direction: column;
  }

  .g-nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 20px;
    border-bottom: 1px solid #222;
    position: sticky;
    top: 0;
    background: var(--g-black);
    z-index: 10;
  }

  .g-nav-logo {
    font-size: 22px;
    font-weight: 900;
    letter-spacing: 0.02em;
    color: var(--g-white);
    text-transform: uppercase;
  }

  .g-nav-logo span { color: var(--g-orange); }

  .g-nav-sub {
    font-size: 13px;
    font-weight: 600;
    color: var(--g-muted);
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }

  .g-main {
    flex: 1;
    max-width: var(--g-max);
    width: 100%;
    margin: 0 auto;
    padding: 32px 20px 48px;
  }

  .g-label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    color: var(--g-orange);
    margin-bottom: 6px;
  }

  .g-h1 {
    font-size: clamp(2.4rem, 9vw, 3.6rem);
    font-weight: 900;
    line-height: 1;
    text-transform: uppercase;
    margin: 0 0 12px;
  }

  .g-h2 {
    font-size: clamp(1.5rem, 5vw, 2rem);
    font-weight: 800;
    line-height: 1.1;
    text-transform: uppercase;
    margin: 0 0 8px;
  }

  .g-body {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    color: #ccc;
    margin-bottom: 24px;
  }

  .g-btn-primary {
    display: block;
    width: 100%;
    padding: 16px 24px;
    background: var(--g-orange);
    color: var(--g-black);
    font-family: 'Barlow Condensed', sans-serif;
    font-size: 20px;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    border: none;
    border-radius: var(--g-radius);
    cursor: pointer;
    transition: opacity 0.15s;
  }
  .g-btn-primary:hover { opacity: 0.88; }
  .g-btn-primary:active { opacity: 0.75; }
  .g-btn-primary:disabled { opacity: 0.4; cursor: not-allowed; }

  .g-btn-ghost {
    display: block;
    width: 100%;
    padding: 14px 24px;
    background: transparent;
    color: var(--g-white);
    font-family: 'Barlow Condensed', sans-serif;
    font-size: 18px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    border: 1px solid #444;
    border-radius: var(--g-radius);
    cursor: pointer;
    transition: border-color 0.15s;
  }
  .g-btn-ghost:hover { border-color: #888; }

  .g-input {
    display: block;
    width: 100%;
    padding: 14px 16px;
    background: #111;
    color: var(--g-white);
    font-family: 'Barlow Condensed', sans-serif;
    font-size: 18px;
    font-weight: 600;
    border: 1px solid #333;
    border-radius: var(--g-radius);
    outline: none;
    box-sizing: border-box;
    transition: border-color 0.15s;
  }
  .g-input:focus { border-color: var(--g-orange); }
  .g-input::placeholder { color: #555; }

  .g-card {
    background: #111;
    border: 1px solid #222;
    border-radius: var(--g-radius);
    padding: 20px;
    margin-bottom: 12px;
  }

  .g-step-row {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    padding: 16px 0;
    border-bottom: 1px solid #1a1a1a;
  }
  .g-step-row:last-child { border-bottom: none; }

  .g-step-num {
    width: 32px;
    height: 32px;
    background: var(--g-orange);
    color: var(--g-black);
    font-size: 18px;
    font-weight: 900;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--g-radius);
    flex-shrink: 0;
  }

  .g-progress-wrap {
    margin-bottom: 24px;
  }

  .g-progress-label {
    font-size: 13px;
    font-weight: 700;
    color: var(--g-muted);
    text-transform: uppercase;
    letter-spacing: 0.08em;
    margin-bottom: 8px;
  }

  .g-progress-bar {
    height: 4px;
    background: #222;
    border-radius: 2px;
    overflow: hidden;
  }

  .g-progress-fill {
    height: 100%;
    background: var(--g-orange);
    border-radius: 2px;
    transition: width 0.3s ease;
  }

  .g-divider {
    border: none;
    border-top: 1px solid #222;
    margin: 24px 0;
  }

  .g-error {
    background: #1a0000;
    border: 1px solid #500;
    border-radius: var(--g-radius);
    padding: 12px 16px;
    font-size: 15px;
    color: #ff6b6b;
    margin-bottom: 16px;
  }

  @media (prefers-reduced-motion: reduce) {
    .g-progress-fill { transition: none; }
    .g-btn-primary, .g-btn-ghost, .g-input { transition: none; }
  }

  @media print {
    .g-nav { display: none; }
    .g-wrap { background: white; color: black; }
    .g-card { border-color: #ddd; background: white; }
  }
`;

export default function GuideLayout() {
  return (
    <>
      <style>{CSS}</style>
      <div className="g-wrap">
        <nav className="g-nav">
          <div className="g-nav-logo">
            Vote<span>Guide</span>
          </div>
        </nav>
        <main className="g-main">
          <Outlet />
        </main>
      </div>
    </>
  );
}
